import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e9e20274"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "episode-item",
  ref: "itemRef"
};
const _hoisted_2 = {
  class: "header_searchbox"
};
const _hoisted_3 = {
  style: {
    "flex": "1",
    "display": "flex",
    "justify-content": "flex-end"
  }
};
import { debounce } from '@/utils/tools';
import HeaderSearch from '../MediaInfo/HeaderSearch.vue';
import MediaInfoItem from '../MediaInfo/MediaInfoItem/index.vue';
export default {
  __name: 'EpisodeItem',
  props: {
    tagItem: Object,
    tagIndex: Number,
    seasonIndex: Number,
    languageIndex: Number,
    getDynamicFormList: Function,
    programType: String
  },
  emits: ['open-drama-info', 'search-subtitle', 'add-subtitle', 'add-media', 'delete-media', 'delete-media-item', 'delete-subtitle-item'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const instance = getCurrentInstance(); // 事件转发

    const openDramaInfo = () => emit('open-drama-info', props.tagItem, props.tagIndex, props.seasonIndex);

    const searchSubtitle = () => emit('search-subtitle', props.tagIndex, props.seasonIndex);

    const addSubtitle = () => emit('add-subtitle', props.tagIndex, props.seasonIndex);

    const addMedia = () => emit('add-media', props.tagIndex, props.seasonIndex);

    const deleteMedia = () => emit('delete-media', props.tagIndex, props.seasonIndex);

    const deleteMediaItem = (c_index, mediaIndex) => emit('delete-media-item', c_index, mediaIndex, props.seasonIndex);

    const deleteSubtitleItem = (c_index, subtitleIndex) => emit('delete-subtitle-item', c_index, subtitleIndex, props.seasonIndex);

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(HeaderSearch, {
        c_index: __props.languageIndex,
        seasonIndex: __props.seasonIndex,
        class: "drama-search-input",
        style: {
          "padding": "5px 0 10px 0"
        },
        isShowBtns: false,
        "form-list": __props.getDynamicFormList(__props.languageIndex, __props.seasonIndex, __props.tagIndex),
        "form-data": __props.tagItem,
        episodeIndex: __props.tagIndex,
        "program-type": "tv_series",
        disabled: __props.tagItem.releaseStatus == 'online'
      }, {
        customBtn: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "text",
          onClick: openDramaInfo
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('信息')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "text",
          onClick: searchSubtitle
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('搜索字幕')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "text",
          onClick: addSubtitle
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加字幕')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "text",
          onClick: addMedia
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加影片')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "text",
          onClick: deleteMedia
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["c_index", "seasonIndex", "form-list", "form-data", "episodeIndex", "disabled"])]), _createVNode(MediaInfoItem, {
        programType: __props.programType,
        formData: [__props.tagItem],
        c_index: __props.tagIndex,
        seasonIndex: __props.seasonIndex,
        onAddMedia: addMedia,
        onDeleteMediaItem: deleteMediaItem,
        onAddSubtitle: addSubtitle,
        onDeleteSubtitleItem: deleteSubtitleItem
      }, null, 8, ["programType", "formData", "c_index", "seasonIndex"])], 512);
    };
  }

};